import script from "./RadioResource.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioResource.vue?vue&type=script&setup=true&lang=js"

import "./RadioResource.vue?vue&type=style&index=0&id=0885b63a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0885b63a"]])

export default __exports__